import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useRoute } from "wouter";

import { DealerVehicleResultsRoute } from "../../navigation/DealerRoutes";
import { Button } from "../../ui/Button/Button";
import { useTireSize } from "../Tires/Results/Filters/TireSizeFilters/useTireSize";
import { useTireSizeOptions } from "../Tires/Results/Filters/TireSizeFilters/useTireSizeOptions";
import { secondaryTireFilters } from "../Tires/Results/Filters/secondaryTireFilters";

export const TireSizeOptions: FunctionComponent = () => {
  const tireSizeOptions = useTireSizeOptions();
  const [, setVehicleSubmodelTiresizeId] = useTireSize();
  const { t } = useTranslation();
  const [isVehicle] = useRoute(DealerVehicleResultsRoute);

  if (!isVehicle) {
    return <div className="py-2 md:py-4" />;
  }

  return (
    <nav className="tw-vehicle-header__tire-size" role="tablist">
      {tireSizeOptions.map(
        ({
          checked,
          formattedTireSize,
          secondaryFormattedTireSize,
          sizeTypeDescription,
          vehicleSubmodelTiresizeId,
        }) => (
          <Button
            onClick={(): void => {
              setVehicleSubmodelTiresizeId(
                vehicleSubmodelTiresizeId,
                secondaryTireFilters
              );
            }}
            aria-label="selectTireSize"
            className="tw-vehicle-header__tire-size-option"
            key={vehicleSubmodelTiresizeId}
            role="tab"
            selected={checked}
          >
            <div className="text-xl font-medium">{sizeTypeDescription}</div>
            <div>
              {secondaryFormattedTireSize ? (
                <>
                  <span className="font-light mr-2">
                    {t("searchResults.front")}:
                  </span>
                  <strong>{formattedTireSize}</strong>
                  <br />
                  <span className="font-light mr-2">
                    {t("searchResults.rear")}:
                  </span>
                  <strong>{secondaryFormattedTireSize}</strong>
                </>
              ) : (
                <>
                  <span className="font-light mr-2">
                    {t("searchResults.size")}:
                  </span>
                  <strong>{formattedTireSize}</strong>
                </>
              )}
            </div>
          </Button>
        )
      )}
    </nav>
  );
};
